import { useTranslation } from "react-i18next";

const getQuickLinks = (role) => {
  const { t } = useTranslation();
  const farmersQL = [
    {
      label: t("My Farms"),
      type: "MyFarm",
      route: "/farmer/farms",
    },
    // TODO: Remove this after the support for adding crop from Farm screen is implemented
    {
      label: t("Crops"),
      type: "traceQL",
      route: "/farmer/crops",
    },
    {
      label: t("Program"),
      type: "program",
      route: "/farmer/programs",
    },
    {
      label: t("Crop Doctor"),
      type: "cropHealthQL",
      route: "/farmer/crop-health",
    },
    {
      label: t("Soil Testing"),
      type: "soilTestingQL",
      route: "/soil-testing",
    },
    {
      label: t("Tutorials"),
      type: "tutorialsQL",
      route: "/farmer/tutorials",
    },
    // {
    //   label: t("Crop Care"),
    //   type: "cropCareQL",
    //   route: "/farmer/nutrition-deficiency-detection",
    // },
    {
      label: t("Satellite Data Report"),
      type: "satelliteDataReportQL",
      route: "/farmer/satellite-data-report-dates",
    },
    {
      label: t("Dehaat Marketplace"),
      type: "dehaatMarketPlaceQL",
      route: "/farmer/dehaat",
    },
    {
      label: t("Biochar"),
      type: "biomassProcurement",
      route: "/biochar",
    },
    {
      label: t("Weather Alerts"),
      type: "WeatherAlertsQL",
      route: "/weather-subscription-alerts",
    },
  ];

  const fpoQL = [
    {
      label: t("Directors & CEO"),
      type: "directorsQL",
      route: "/fpo/members",
    },
    {
      label: t("Organization Data"),
      type: "organizationDataQL",
      route: "/fpo/data",
    },
    {
      label: t("Financial"),
      type: "financialQL",
      route: "/fpo/financials",
    },
    {
      label: t("Documents"),
      type: "documentsQL",
      route: "/fpo/documents-list",
    },
    {
      label: t("Add Farmer"),
      type: "addFarmerQL",
      route: "/fpo/farmers",
    },
    {
      label: t("Update on WhatsApp"),
      type: "whatsappUpdateQL",
      route: "#",
    },
    {
      label: t("Offers"),
      type: "addFarmerQL",
      route: "/fpo/buying-offers",
    },
  ];

  const buyerQL = [
    {
      label: t("Commodities"),
      type: "commoditiesQL",
      route: "/buyer/view-available-commodities",
    },
    {
      label: t("Trace"),
      type: "traceQL",
      route: "/buyer/trace",
    },
    {
      label: t("Requirement"),
      type: "requirementsQL",
      route: "/buyer/requirement",
    },
    {
      label: t("Trades"),
      type: "tradesQL",
      route: "/buyer/bids-trades",
    },
    {
      label: t("Carbon Reduction"),
      type: "decarbonizationQL",
      route: "/buyer/decarbonization",
    },
    {
      label: t("Market Rate"),
      type: "marketRateQL",
      route: "/market-price",
    },
    {
      label: t("MarketPlace"),
      type: "marketPlaceQL",
      route: "/buyer/market-place",
    },
  ];

  const serviceProviderQL = [
    {
      label: t("Services"),
      type: "serviceQL",
      route: "/service-provider/additional-details",
    },
    {
      label: t("Profile"),
      type: "profileQL",
      route: "/service-provider/profile",
    },
  ];

  const popManagerQL = [
    {
      label: t("Soil Test (External)"),
      type: "labTestQL",
      route: "/create-external-soil-report",
    },
    {
      label: t("Manage Farmers"),
      type: "manageFarmerQL",
      route: "/farmers-list",
    },
    {
      label: t("Franchise"),
      type: "franchiseQL",
      route: "/franchise-management",
    },
    {
      label: t("Weather Alerts"),
      type: "WeatherAlertsQL",
      route: "/weather-subscription-alerts",
    },
  ];
  const areaManagerQL = [
    {
      label: t("Soil Test (External)"),
      type: "labTestQL",
      route: "/create-external-soil-report",
    },
    {
      label: t("Manage Farmers"),
      type: "manageFarmerQL",
      route: "/farmers-list",
    },

    {
      label: t("Biochar Orders"),
      type: "franchiseQL",
      route: "/biochar-orders-list",
    },
    {
      label: t("Biomass Procurement"),
      type: "biomassProcurement",
      route: "/procurement-list",
    },
    {
      label: t("Pickup Orders"),
      type: "pickupOrder",
      route: "/pickup-orders",
    },
    {
      label: t("Expense Tracker"),
      type: "expenseQL",
      route: "/pickup-order-expense-tracker",
    },
    {
      label: t("Weather Alerts"),
      type: "WeatherAlertsQL",
      route: "/weather-subscription-alerts",
    },
  ];
  const vleQL = [
    {
      label: t("Soil Test (External)"),
      type: "labTestQL",
      route: "/create-external-soil-report",
    },
    {
      label: t("Biomass Procurement"),
      type: "biomassProcurement",
      route: "/procurement-list",
    },
    {
      label: t("Pickup Orders"),
      type: "pickupOrder",
      route: "/pickup-orders",
    },
    {
      label: t("Invoicing"),
      type: "documentsQL",
      route: "/initiate-invoice",
    },
    {
      label: t("Weather Alerts"),
      type: "WeatherAlertsQL",
      route: "/weather-subscription-alerts",
    },
  ];

  const plantInchargeQL = [
    {
      label: t("Inwards"),
      type: "inwardsQL",
      route: "/pickup-order-list",
    },
  ];

  if (role === "farmer") return farmersQL;
  if (role === "fpo") return fpoQL;
  if (role === "buyer") return buyerQL;
  if (role === "service_provider") return serviceProviderQL;
  if (role === "pop_manager") return popManagerQL;
  if (role === "area_manager") return areaManagerQL;
  if (role === "vle") return vleQL;
  if (role === "plant_incharge") return plantInchargeQL;
};

export default getQuickLinks;
